/* @flow */
import Reflux from "reflux";

const CustomerHistoryAction = Reflux.createActions(["loadCatSLItems", "loadArticles"]);

export default CustomerHistoryAction;
